module.exports = {"body":"<h2>Click the links to download the work tracking excel files</h2>\n<ul>\n<li><a href=\"excelFiles/teri-work-reporting.zip\">.zip of all files</a></li>\n<li><a href=\"excelFiles/Ryan-weekly-individual.xlsx\">Ryan Work Tracking</a></li>\n<li><a href=\"excelFiles/Derek-weekly-individual.xlsx\">Derek Work Tracking</a></li>\n<li><a href=\"excelFiles/Phil-weekly-individual.xlsx\">Phil Work Tracking</a></li>\n<li><a href=\"excelFiles/Jordan-weekly-individual.xlsx\">Jordan Work Tracking</a></li>\n<li><a href=\"excelFiles/weekly-team.xlsm\">Weekly Team Work Tracking</a></li>\n</ul>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./work-tracking/index.md
 ** module id = 489
 ** module chunks = 0
 **/